import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../Zone/zone.css';

function WorldReligion() {
  const [showPDF, setShowPDF] = useState(false);

  const handleViewPDF = () => {
    setShowPDF(true);
  };

  const handleClosePDF = () => {
    setShowPDF(false);
  };

  return (
    <div style={{
      backgroundColor: 'black',
      minHeight: '100vh',
      padding: '20px 15px',
      color: 'white',
      fontFamily: 'Arial, sans-serif'
    }}>

      {/* PDF Buttons */}
      <div style={{ textAlign: 'right', marginBottom: '15px' }}>
        {!showPDF && (
          <button
            onClick={handleViewPDF}
            style={buttonStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#666'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#444'}
          >
            📄 View PDF
          </button>
        )}
        {showPDF && (
          <button
            onClick={handleClosePDF}
            style={buttonStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#666'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#444'}
          >
            ❌ Close PDF
          </button>
        )}
      </div>

      <h1 style={{
        textAlign: 'center',
        marginBottom: '40px',
        fontSize: '26px',
      }}>
        🌏 World Religion - Video Posters
      </h1>

      {/* Video Posters */}
      <div style={{
        display: 'flex',
        gap: '40px',
        justifyContent: 'center',
        flexWrap: 'wrap',
        maxWidth: '900px',
        margin: 'auto',
        marginBottom: '50px'
      }}>
        <div style={videoCardStyle}>
          <iframe
            width="100%"
            height="200"
            src="https://www.youtube.com/embed/nxhSOcyPCVo"
            title="World Religion Video 1"
            frameBorder="0"
            style={{ display: 'block' }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      {/* PDF Preview Section */}
      {showPDF && (
        <div style={{
          maxWidth: '1000px',
          margin: '30px auto',
          border: '1px solid #555',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 0 10px #333'
        }}>
          <iframe
            src="/viewpdf.pdf#toolbar=0"
            title="World Religion Poster"
            width="100%"
            height="500px"
            style={{ border: 'none' }}
          ></iframe>
        </div>
      )}

      {/* Back Button */}
      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <Link
          to="/zones"
          style={{
            backgroundColor: '#444',
            color: '#fff',
            padding: '10px 22px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontSize: '14px',
            boxShadow: '0 0 5px #fff',
            transition: 'background 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#666'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#444'}
        >
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

/* Button Styles */
const buttonStyle = {
  backgroundColor: '#444',
  color: '#fff',
  padding: '8px 18px',
  borderRadius: '20px',
  border: 'none',
  cursor: 'pointer',
  boxShadow: '0 0 5px #fff',
  fontSize: '14px'
};

/* Video Card Styles */
const videoCardStyle = {
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 0 10px #222',
  flex: '0 0 42%'
};

export default WorldReligion;
